import './NoMatch.scss';

import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

const notFoundImage = window.__env.NOT_FOUND_IMAGE || "";

export default function NoMatch() {
  return (
    <Container className="no-match my-4 text-center">
      <div className="mb-3">
        <img src={notFoundImage} height={300} alt="Got lost?" />
      </div>
      <h3 className="mb-3">Oops, this is awkward <b>:/</b></h3>
      <p>The page you are looking for doesn't exist or is currently under development.</p>
      <Link to={window.__env.AFTER_LOGIN_ROUTE || "/dashboard"}>
        <FontAwesomeIcon icon={solid('home')} />
        <span className="ms-2">Go back to the home page</span>
      </Link>
    </Container>
  )
}
